"use client";
import React, { useEffect, useState } from 'react';
// import '@/templates/Showroom/variants/default/styles/public.scss';
import Menu from '../../components/Menu/Menu';
import HomeButton from '../../components/HomeButton/HomeButton';
import { useModules } from '@/contexts/ModuleProvider';
// import { ModuleComponentMap } from '@/types/module';
// import LandingPage from './features/LandingPage/LandingPage'; // Commented out unused import
import ButtonHome from '../../components/HomeScreen/ButtonHome/ButtonHome';
import { SettingsLayout } from './features/SettingTabs';
import { SettingIcon } from '@/templates/Showroom/utils/icons';
import SideNav from "../../components/SideNav";
import FloatingButtons from "../../components/Logo/FloatingButtons";
import { FrameMinimaps } from '../../components/Minimap';

export default function Showroom({ children }: { children: React.ReactNode }) {

    const { activeModules } = useModules();
    const [isSettingsOpen, setIsSettingsOpen] = useState(false);
    const [isSideNavOpen, setIsSideNavOpen] = useState(false);


    useEffect(() => {
        if (Object.values(activeModules)?.length > 0) {
            Object.values(activeModules).forEach((mod) => {
                let name = mod.name_module;

                if (name === "minimap" || name === "google_map") {
                    name = "map";
                }
                const nav = document.querySelector(`#nav_${name}`);
                nav?.classList.add("activeModule");
            });
        }
    }, [activeModules]);

    const handleHomeClick = () => {
        setIsSettingsOpen(prev => !prev);
    };

    const handleCloseSettings = () => {
        setIsSettingsOpen(false);
    };

    const handleMenuClick = () => {
        setIsSideNavOpen(true);
    };

    const handleSideNavClose = () => {
        setIsSideNavOpen(false);
    };

    return (
        <div className="flex h-screen related">
            {/* <LandingPage /> */}
            {/* Menu Button */}
            <div className="fixed z-50 top-4 left-4">
                <Menu onClick={handleMenuClick} isOpen={isSideNavOpen} />
            </div>
            {/* Floating Buttons */}
            <div className="fixed z-50 top-4 right-4">
                <FloatingButtons />
            </div>

            {/* FrameMinimaps đặt lên trên cùng với style fixed + z-index cao */}
            <div className="fixed top-0 left-0 z-50 pointer-events-none">
                <FrameMinimaps />
            </div>

            {/* SideNav */}
            <SideNav isOpen={isSideNavOpen} onClose={handleSideNavClose} />
            <HomeButton />
            {/* ButtonHome component that toggles the settings panel */}
            <ButtonHome
                icon={<SettingIcon />}
                title="Settings"
                position={{ bottom: '5%', left: '5%' }}
                onClick={handleHomeClick}
            />
            {/* Settings Layout that appears when the ButtonHome is clicked */}
            <SettingsLayout
                isOpen={isSettingsOpen}
                onClose={handleCloseSettings}
            />
            <div className="flex items-center justify-center w-full h-full bg-gray-500">
                {children}
            </div>
        </div>
    );
}
